import { EventBaseSchema, eventType } from '@eigtech/event-stream-types';
import { z } from 'zod';
import { serviceName } from '../base.js';
export const inspectionsServiceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const InspectionsServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType(),
}));
